import React from 'react';
import { UIHeading2 } from '@cian/ui-kit';

import { ISidebarCardParams, SidebarCard } from '../SidebarCard';
import * as s from './SidebarTips.css';

interface ISidebarAddPostTip {
  title: React.ReactNode;
  children?: React.ReactNode;
  theme?: ISidebarCardParams['theme'];
  image?: React.ReactNode;
}

/**
 * Карточка с советами в сайдбаре
 */
export const SidebarTip = ({ title, theme, image, children }: ISidebarAddPostTip) => (
  <SidebarCard theme={theme}>
    {image && <div className={s['image-wrapper']}>{image}</div>}

    <UIHeading2>{title}</UIHeading2>

    {children && <div className={s['content-wrapper']}>{children}</div>}
  </SidebarCard>
);
